// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_11DYm2"};